<template>
  <div class="appBody bg-white">
<!--    <div class="shareImg position-fixed cursor-pointer">-->
<!--      <img @click="onShare" src="/static/img/pro/share.png" alt="" class="">-->
<!--    </div>-->
    <little-header></little-header>
    <div  v-if="!loading">
      <div v-if="docObj && docObj.id">
        <div class="session-doc-head">
          <div class="mx-4 pt-20">
            <p class="mb-0 text-white font-13 line-18 van-multi-ellipsis--l2">
              {{docObj.title}}
            </p>
          </div>
          <!--        <div class="bottom-shade d-flex align-items-center justify-content-between">-->
          <!--          <div class="name text-white font-15 line-15 text-truncate" v-if="docObj.creatorUser">-->
          <!--            {{docObj.creatorUser.nickname}}-->
          <!--          </div>-->
          <!--&lt;!&ndash;          <a href="#" class="guan font-13 d-flex align-items-center justify-content-center text-white">关注</a>&ndash;&gt;-->
          <!--        </div>-->
          <!--        <div class="avatar">-->
          <!--          <img class="img" :src="avatarUrl" alt="">-->
          <!--        </div>-->
        </div>
        <div class="doc-summary mb-1" v-if="docObj.summary">
          <p>{{docObj.summary}}</p>
        </div>
        <div v-if="showBtns">
          <div v-if="isShow" class="stroy-open
          pt-0 bg-white color-0d justify-content-center align-items-center font-12"
               @click="open">
            <img class="mr-2 shou" src="/static/img/pro/kai.png" alt="">展开
          </div>
          <div v-if="!isShow" class=" stroy-close
          pt-0 bg-white color-0d justify-content-center align-items-center font-12"
               @click="close">
            <img class="mr-2 shou" src="/static/img/pro/shou.png" alt="">收起
          </div>
        </div>


        <van-row class="doc-tongji">
          <van-col class="study-sum d-flex align-items-center color-99 font-11 line-11">
            <img class="mr-1" src="/static/img/pro/pp.png" alt="">
            {{docObj.learnedCount?docObj.learnedCount:0}}
          </van-col>
          <!--        <van-col class="collect-sum pl-3 d-flex align-items-center color-99 font-11 line-11">-->
          <!--          <img class="mr-2" src="/static/img/pro/xx.png" alt="">-->
          <!--          12000-->
          <!--        </van-col>-->
          <van-col v-if="docObj.score" class="comment-sum  pl-3 d-flex align-items-center color-99 font-11 line-11">
            <img class="mr-2" src="/static/img/pro/zzx.png" alt="">
            已评分：<span class="text-primary font-weight-600 mr-1">4</span> 分
          </van-col>
          <a v-if="docObj.enableDownload && docObj.docResource && docObj.docResource.url"
             :href="uploadresUrl+docObj.docResource.url" :download="docObj.docResource.name"
             class="ml-auto d-flex justify-content-end align-items-center text-primary font-11 line-11">
            <img class="mr-2" src="/static/img/pro/dd.png" alt="">
            下载文档
          </a>
        </van-row>
        <div class="ml-12 mr-12 doc-index pb-3 position-relative d-flex justify-content-center">
          <pdf
            :src="pdfSrc"
            :page="currentPage"
            @num-pages="pageCount=$event"
            @page-loaded="currentPage=$event"
          >
          </pdf>
          <router-link v-if="pdfSrc" :to="'/doc/detail/'+docObj.id" class="position-absolute tap">
            <img src="/static/img/pro/tap.gif">
          </router-link>
        </div>

        <van-row class="doc-tags" type="flex" v-if="docObj.tag && docObj.tag.length>0">
          <van-col class="tag" v-for="(tag,index) in docObj.tag" :key="index">{{tag}}</van-col>
        </van-row>
        <van-row class="video-stat d-flex align-items-center my-2 mx-3">
          <like-component :type="mainType" :main-id="sessionId" status="true"></like-component>
          <rate-component :type="mainType" :main-id="sessionId"></rate-component>
        </van-row>

        <comment-component :type="mainType" :main-id="sessionId"></comment-component>

      </div>
      <no-data v-else text="暂无文档内容"></no-data>
    </div>
    <van-loading class="my-5" v-else size="24px" vertical>加载中...</van-loading>
    <little-footer></little-footer>
  </div>
</template>

<script>
  import littleFooter from '@/page/lecturer/components/littleFooter';
  import LittleHeader from "@/components/littleHeader";
  import Vue from 'vue';
  import {Icon, SwipeCell,Button,Col, Row,Loading,Card} from 'vant';
  import {mapState} from "vuex";
  import pdf from 'vue-pdf';
  import NoData from "@/components/noData";
  import CommentComponent from './component/commentComponent'
  import RateComponent from './component/rateComponent';
  import LikeComponent from './component/likeComponent';

  Vue.use(Loading);
  Vue.use(Card);
  Vue.use(Col);
  Vue.use(Row);
  Vue.use(Button);
  Vue.use(SwipeCell);
  Vue.use(Icon);
  export default {
    name: "docSession",
    data() {
      return {
        sessionId: '',
        docObj: {},
        avatarUrl: '',
        currentPage: 1,       // pdf文件页码
        pageCount: 1,
        fileType: 'pdf',      // 文件类型
        pdfSrc: '',
        showBtns: false,
        isShow: false,
        loading: false,
        mainType: 'session-doc',
      }
    },
    components: {
      LittleHeader,
      littleFooter,
      pdf,
      NoData,
      CommentComponent,
      RateComponent,
      LikeComponent,
    },
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl,
        recordStudyTip: state => state.recordStudy
      })
    },
    mounted() {
      this.sessionId = this.$route.params['id'];
      this.loadData();
      this.contentHeight = $('body').css('lineHeight').substring(0, $('body').css('lineHeight').length-2)*2.75;
      this.$nextTick(() => {
        setTimeout(() => {
          let el = $('.doc-summary');
          if (el) {
            let summaryHeight = el.find('p').height();
            if (summaryHeight > this.contentHeight) {
              el.css('height', this.contentHeight);
              this.isShow = true;
              this.showBtns = true;
            } else {
              // el.css('height', summaryHeight+24);
              this.showBtns = false;
            }
          }
        },1000);
      });
    },
    methods: {
      open() {
        $('.doc-summary').css('height', 'auto');
        this.isShow = false;
      },
      close() {
        $('.doc-summary').css('height',this.contentHeight);
        this.isShow = true;
      },
      loadData() {
        this.loading = true;
        this.$store.dispatch('getSessionDocForLearnerUrl', {id: this.sessionId}).then(
          (res) => {
            if (res) {
              this.loading = false;
              this.docObj = res;
              if (this.docObj.creatorUser && this.docObj.creatorUser.avatarUrl) {
                this.avatarUrl = this.uploadresUrl + this.docObj.creatorUser.avatarUrl;
              }
              this.loadPdf();
              // 如果超出学习时间，可以观看但不再记录学习
              if(!this.docObj.recordStudy) {
                setTimeout(()=>{
                  this.$toast({
                    message: this.recordStudyTip,
                    duration: 3000
                  });
                }, 1000);
              }
            }
          }
        );
      },
      loadPdf() {
        this.pdfSrc = pdf.createLoadingTask(window.location.protocol + '//' + this.uploadresUrl + this.docObj.docResource.url);
      },
      // onShare() {
      //   //把生成海报需要的信息传入cookie
      //   this.shareObj = this.docObj;
      //   this.shareObj.qrcodeUrl = window.location.href;
      //   this.shareObj.fromPageType = 'session';
      //   localStorage.setItem('share_obj', JSON.stringify(this.shareObj));
      //   this.$router.push('/share-poster');
      // },
    }
  }
</script>

<style scoped lang="scss">
  $browser-default-font-size: 16px !default;
  @function pxTorem($px) {
    @return $px / $browser-default-font-size * 1rem;
  }
  .video-stat {
    margin: 0 pxTorem(10px) 0 pxTorem(10px);
    min-height: pxTorem(40px);
    border-bottom: pxTorem(1px) solid #eeeeee;

    .fs-img {
      height: pxTorem(12px);
    }

    .progress2 {
      width: pxTorem(40px);
      height: pxTorem(10px) !important;
      border-radius: pxTorem(2px);
    }

    .guanzhu-btn {
      background: white;
      width: pxTorem(64px);
      height: pxTorem(25px);
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .session-doc-head {
    height: pxTorem(131px);
    background: url("/static/img/pro/doc_bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
  }

  .bottom-shade {
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #00000024;
    height: pxTorem(44px);

    .name {
      margin-left: pxTorem(100px);
    }

    .guan {
      border-radius: pxTorem(10px);
      background: transparent;
      border: 1px solid #ffffff;
      margin-right: pxTorem(32px);
      height: pxTorem(25px);
      width: pxTorem(64px);
    }
  }

  .avatar {
    position: absolute;
    left: pxTorem(16px);
    bottom: pxTorem(12px);

    .img {
      width: pxTorem(50px);
      height: pxTorem(50px);
      border-radius: 50%;
    }
  }

  .doc-summary {
    margin: pxTorem(16px) pxTorem(16px) pxTorem(16px) pxTorem(16px);
    border-bottom: pxTorem(1px) solid #eeeeee;
    font-size: pxTorem(11px);
    color: #333333;
    height: pxTorem(72px);
    overflow: hidden;
    p {
      margin-right: pxTorem(4px);
    }
  }

  .doc-tongji {
    margin: pxTorem(16px) pxTorem(16px) pxTorem(16px) pxTorem(22px);

    img {
      height: pxTorem(12px);
    }
  }

  .doc-index {
    > span {
      width: 69%;
    }

    .tap {
      top: 50%;
      left: 50%;
      margin-left: pxTorem(-55px);
      margin-top: pxTorem(-55px);

      img {
        width: pxTorem(110px);
        height: pxTorem(110px);
      }
    }
  }

  .doc-tags {
    margin: pxTorem(16px) pxTorem(16px) pxTorem(16px) pxTorem(16px);
    flex-wrap: wrap;

    .tag {
      padding: pxTorem(2px) pxTorem(8px) pxTorem(2px) pxTorem(8px);
      background-color: #eeeeee;
      border-radius: pxTorem(2px);
      margin-right: pxTorem(8px);
      margin-bottom: pxTorem(8px);
      font-size: pxTorem(10px);
      color: #666666;
      line-height: pxTorem(14px);
    }
  }
  .stroy-open, .stroy-close {
    cursor: pointer;
    display: flex;
    background-color: #4d77c3;
    color: white;
    padding-top: .5rem;
  }
  .stroy-close .shou, .stroy-open .shou {
    width: 3% !important;
  }
</style>
